import { createSelector } from 'reselect';
var selectFurnitureState = function (state) { return state.get('furniture'); };
export var selectLoading = createSelector(selectFurnitureState, function (furnitureState) { return furnitureState.get('loading'); });
export var selectLoadingComplete = createSelector(selectFurnitureState, function (furnitureState) {
    return !furnitureState.get('loading') && furnitureState.get('loaded');
});
export var selectFurnitures = createSelector(selectFurnitureState, function (furnitureState) { return furnitureState.get('data'); });
